import React, { Fragment } from "react";
import { Figure } from "react-bootstrap";
import styled from "styled-components";
import palette from "../../lib/styles/palette";

const FormDiv = styled.div`
  height: 100vh;
  background: ${palette.gray[2]};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const TitleForm = () => {
  return (
    <Fragment>
      <FormDiv>
        <Figure>
          <Figure.Caption>
            <h1>BIG GAME</h1>
            <h1>안녕하세요.</h1>
          </Figure.Caption>
        </Figure>
      </FormDiv>
    </Fragment>
  );
};

export default TitleForm;
